<div class="text-center py-3" *ngIf="exhibits_loading">
  <i class="fas fa-spinner fa-pulse fa-2x"></i>
</div>
<div *ngIf="!exhibits_loading">
  <h6 class="px-3 d-flex align-items-center justify-content-between">
    <span>Exhibits - <app-badge badgeType="primary">{{ exhibits.length }}</app-badge></span>
    <a *ngIf="exhibits.length > 0"
       class="btn btn-sm btn-outline-primary"
       [href]="downloadExhibitsUrl()">
      <i class="fas fa-file-archive mr-1"></i> Download Zip
    </a>
  </h6>
  <table class="table">
    <tbody>
      <tr *ngFor="let exhibit of exhibits">
        <th class="align-top" scope="row">{{ exhibit.title }}</th>
        <td>
          <a [href]="'/documents/' + exhibit.id + '/download'" [title]="(exhibit.document_type_name || '') + (exhibit.document_type_name && exhibit.notes ? ' — ' : '') + (exhibit.notes || '')">{{ exhibit.name }}</a>
        </td>
        <td>{{ exhibit.document_type_name }}</td>
      </tr>
    </tbody>
  </table>
</div>
